import { render, staticRenderFns } from "./CustomTextarea.vue?vue&type=template&id=74221bba&scoped=true&"
import script from "./CustomTextarea.vue?vue&type=script&lang=js&"
export * from "./CustomTextarea.vue?vue&type=script&lang=js&"
import style0 from "./CustomTextarea.vue?vue&type=style&index=0&id=74221bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74221bba",
  null
  
)

export default component.exports